export default __webpack_public_path__ + "static/media/strava-redesign.593a6269.png";